import { render, staticRenderFns } from "./PrkTable.vue?vue&type=template&id=28983624&scoped=true&"
import script from "./PrkTable.vue?vue&type=script&lang=js&"
export * from "./PrkTable.vue?vue&type=script&lang=js&"
import style0 from "./PrkTable.vue?vue&type=style&index=0&id=28983624&scoped=true&lang=scss&"
import style1 from "./PrkTable.vue?vue&type=style&index=1&id=28983624&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28983624",
  null
  
)

export default component.exports